<script lang="ts">
	//Services
	import { format } from 'src/services/i18n';

	//Design system components
	import { ButtonV2, Stack, Text } from '@Shelly/shelly-design-system';
	import { push } from 'svelte-spa-router';
</script>

<Stack
	direction="column"
	directionMobile="row"
	align="between"
	alignMobile="none"
	gap="m"
	class="align-items-center"
>
	<div>
		<Text styleType="body-medium" class="mb-s">{$format('data_act_title', { default: 'Data Act' })}</Text>
		<Text styleType="body-small" class=" text-color-muted"
			>{$format('description_read_data_act', { default: 'Read the data act' })}</Text
		>
	</div>

	<ButtonV2 size="m" variant="secondary" on:click={() => push(`/terms-and-conditions`)}
		>{$format('button_open', {
			default: 'Open',
		})}</ButtonV2
	>
</Stack>
